import { render, staticRenderFns } from "./gastosinternos.vue?vue&type=template&id=73b7ce6e"
import script from "./gastosinternos.vue?vue&type=script&lang=js"
export * from "./gastosinternos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports